<template>
  <div class="batchCreate">
    <MapModal
      :modalNode="modalNode"
      :title="ModelNase.title"
      :id="ModelNase.id"
      :close="closeOneSelf"
    >
      <template slot="content">
        <div class="content">
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            class="settings"
            label-width="78px"
            label-position="right"
          >
            <!-- <el-form-item label="分组名称" prop="name">
              <el-input
                v-model="form.name"
                :disabled="disabled_name"
                class="formName"
              ></el-input>
            </el-form-item> -->

            <el-form-item label="布设路径" prop="setPath">
              <el-radio-group v-model="form.setPath" size="small">
                <el-radio :label="3">手动描点</el-radio>
                <el-radio :label="8">导入文件</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="密集程度"
              prop="density"
              class="formNum"
              v-if="form.setPath == 3"
            >
              <!-- <el-input-number v-model="form.density"  :min="0" :max="9999" ></el-input-number> -->
              <el-input
                v-model="form.density"
                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+2)}"
              ></el-input>
              <span
                style="color:aliceblue;position: relative;left: -80px;display: inline-block;
  width: 50px;font-size: 13px"
                >/ 米</span
              >
            </el-form-item>
            <el-form-item label=" " class="btns">
              <el-button
                type="primary"
                style="width:180px;position: relative;left:16px"
                @click="choosePath"
                >{{ form.setPath == 3 ? "选择路径" : "选择文件" }}</el-button
              >
            </el-form-item>
            <el-form-item class="submitBtn btns">
              <el-button @click="closeOneSelf">取消</el-button>
              <el-button type="primary" @click="onSubmit">下一步</el-button>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </MapModal>
  </div>
</template>

<script>
const MapModal = () => import("@/components/common/mapModal/Index");
import * as batchCreateMap from "./batchCreateMap.js";
export default {
  data() {
    return {
      ModelNase: {
        title: "批量创建",
        id: "ModelNase",
      },
      modalNode: {
        ModelNase: {
          show: true,
          loading: false,
          // 样式配置 定位使用
          // style: "margin: 106px 0 0 -706px;",
          offset: {
            // 默认弹出层偏移
            // x: 106,
            // y: -376,
            x: 55,
            y: -330,
            // unit: "px", // 默认px
          },
          width: "330px",
          // auto 自适应
          height: `${document.querySelector(".cesium-widget").offsetHeight -
            650}px`, // 配置模态框中心高度
          // height: `${document.querySelector(".cesium-widget").offsetHeight -
          //   30}px`, // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: false,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      form: {
        name: "",
        setPath: 3,
        density: 20,
      },
      rules: {
        name: [{ required: true, message: "请输入分组名称", trigger: "blur" }],
        modelName: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
      },
      disabled_name: false,
    };
  },
  components: {
    MapModal,
  },
  props: {},

  created() {},
  mounted() {
    this.$eventBus.$on("startDrawGraphic", () => {
      this.modalNode.ModelNase.show = true;
      batchCreateMap.startDrawGraphic();
    });
    this.$eventBus.$on("clear_graphicLayer", () => {
      batchCreateMap.deleteAll();
    });
    batchCreateMap.createdGraphicLayer();
  },
  methods: {
    choosePath() {
      if (this.form.setPath == 3) {
        batchCreateMap.deleteAll();
        batchCreateMap.stopDrawShowFun();
        batchCreateMap.startDrawGraphic(this.form.density);
      }
    },
    onSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.setPath == 3) {
            if (batchCreateMap.positions.length) {
              this.modalNode.ModelNase.show = false;
              this.$emit("createModel", batchCreateMap.positions);
              batchCreateMap.setCameraView();
            } else {
              this.$message({
                message: "请先手动描点！",
                duration: 1000,
                type: "warning",
              });
            }
          } else {
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeOneSelf() {
      batchCreateMap.deleteAll();
      this.modalNode.ModelNase.show = false;
      this.$emit("openState");
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/box.scss";

.batchCreate {
  /deep/.el-form.settings {
    width: 100%;
    @include hvcenter(column);
    // padding: 8px 0 0 0;
    padding: 8px 0 14px 0;
    .el-form-item {
      width: 100%;
      padding: 0 0 0 7px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 18px;
      .el-form-item__label {
        margin-bottom: 0px;
        font-size: 12px;
        @include font_color("t_color_op1");
        padding: 0;
        flex-grow: 0;
        line-height: 32px;
        padding-right: 10px;
      }
      .el-form-item__content {
        margin-left: 0px !important;
        font-size: 12px;
        display: flex;
        align-items: center;
        flex-grow: 1;
        line-height: 32px;
        .el-select {
          @include select_base();
        }
        .el-autocomplete {
          @include select_base();
        }
        .el-input {
          @include input_base();
        }
        .el-textarea {
          @include textarea_base();
        }
        .el-checkbox {
          @include checkbox_base();
        }
      }
      .showInline {
        margin: 10px 6px;
        width: 96px;
        display: inline-block;
        text-align: right;
        @include lheight(26);
        font-size: 11px;
        @include font_color("t_color_op1");
        .el-input-number {
          margin-left: -5px !important;
          @include input_number();
        }
        .el-input-number__increase {
          height: 32px;
          line-height: 32px;
        }
        .el-input__inner {
          width: 100% !important;
        }
      }
      &:first-child {
        padding: 10px 0 0 7px;
      }
      &.description {
        margin-bottom: 12px;
      }

      &.btns {
        margin-bottom: 12px;
        .el-form-item__content {
          width: 212px;
          @include button_primary();
          @include button_default();
        }
      }
    }
    @include switch_base();
    .el-switch {
      width: 45px;
      margin: 0;
      .el-switch__label {
        width: 28px;
        span {
          width: 28px;
          font-size: 11px;
        }
        &.el-switch__label--left {
          margin-right: 5px;
        }
        &.el-switch__label--right {
          margin-left: 5px;
        }
      }
      .el-switch__core {
        width: 40px !important;
        @include lheight(20);
        margin: 0 5px;
      }
    }
  }
}

.el-radio {
  white-space: break-spaces;
  word-break: break-all;
  .el-radio__input {
    line-height: 18px;
    .el-radio__inner {
      margin: 0 3px 0 0;
      @include background_color("t_color3_op2");
      &::after {
        /* 取消选中状态单选框中间的小圆点显示 */
        display: none;
      }
      &:hover {
        @include border_color("t_color1_op1");
      }
    }
    &.is-checked {
      .el-radio__inner {
        // @include border_color('t_color1_op1');
        // @include background_color('t_color1_op1');
        @include border_color("th_color_op1");
        @include background_color("t_color1_op2");
      }
    }
  }
  .el-radio__label {
    padding-left: 2px;
    color: white;
  }
  &.is-checked {
    .el-radio__label {
      @include font_color("t_color_op1");
    }
    .el-radio__inner {
      background-color: #2281b2 !important;
      // @include background_color("t_color1_op1");
    }
  }
}

/deep/.el-button--default {
  border-color: rgba(255, 255, 255, 0.9) !important;
  background-color: rgba(234, 242, 248, 0.3) !important;
  color: rgba(245, 245, 245, 0.6) !important;
}
.submitBtn {
  display: flex;
  flex-direction: inherit !important;
}
/deep/.el-radio-group {
  margin-top: 9px !important;
}
.formNum /deep/.el-input__inner {
  width: 75px !important;
}
.el-form.settings
  .el-form-item
  .el-form-item__content
  .formNum
  /deep/.el-input {
  width: 80px !important;
  display: inline-block;
}
.formNum .el-radio__label {
  display: flex !important;
}
/deep/.formName .el-input__inner {
  width: 180px !important;
}
.newGroup .el-form.settings .el-switch {
  position: relative;
  left: -7px;
}
.formNum /deep/.el-input__inner {
  width: 75px !important;
}
</style>
